module.exports = __webpack_public_path__ + "static/carmen-sandiego-47838263f2ef26bbeb7c35064472e6bd.png";